"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EllipsesIcon = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { height: "4", viewBox: "0 0 18 4", width: "18", xmlns: "http://www.w3.org/2000/svg", className: className || '' },
        react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { transform: "translate(-1.000000, -8.000000)", fill: "currentColor" },
                react_1.default.createElement("circle", { id: "Oval", cx: "3", cy: "10", r: "2" }),
                react_1.default.createElement("circle", { id: "Oval-Copy", cx: "10", cy: "10", r: "2" }),
                react_1.default.createElement("circle", { id: "Oval-Copy-2", cx: "17", cy: "10", r: "2" })))));
};
exports.default = EllipsesIcon;
//# sourceMappingURL=EllipsesIcon.js.map